import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

function GanttFinanceiroProjeto({ projeto, valorGasto }) {
  if (!projeto) return <div>Carregando gráfico financeiro...</div>;

  // --- NOVA LÓGICA DE VALOR LICITADO ---
  const valorLicitado = parseFloat(projeto.valor_licitado) || 0;
  const valorRepasse = parseFloat(projeto.valor_repasse) || 0;
  const valorContrapartida = parseFloat(projeto.valor_contrapartida) || 0;

  // Se houver valor_licitado > 0, ele será a base.
  // Caso contrário, usa o valor_repasse (ou a soma de repasse + contrapartida, se você preferir alterar abaixo)
  const valorTotal = valorLicitado > 0 ? valorLicitado : valorRepasse;

  const gasto = parseFloat(valorGasto) || 0;
  const valorRestante = Math.max(0, valorTotal - gasto);

  const data = {
    labels: ["Valor Gasto", "Valor Restante"],
    datasets: [
      {
        data: [gasto, valorRestante],
        backgroundColor: [
          "rgba(46, 204, 113, 0.7)", // Gasto (Verde)
          "rgba(52, 152, 219, 0.3)", // Restante (Azul claro)
        ],
        hoverBackgroundColor: [
          "rgba(46, 204, 113, 0.9)",
          "rgba(52, 152, 219, 0.5)",
        ],
        borderColor: ["rgba(46, 204, 113, 1)", "rgba(52, 152, 219, 0.5)"],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "70%",
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          font: { size: 14, family: "'Poppins', sans-serif", weight: "500" },
          padding: 20,
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      tooltip: {
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        titleColor: "#2c3e50",
        titleFont: { size: 16, family: "'Poppins', sans-serif", weight: "600" },
        bodyColor: "#2c3e50",
        bodyFont: { size: 14, family: "'Poppins', sans-serif" },
        borderColor: "#e1e8ed",
        borderWidth: 1,
        padding: 12,
        callbacks: {
          label: function (context) {
            return `${context.label}: R$ ${context.raw.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}`;
          },
        },
      },
    },
  };

  return (
    <div
      style={{
        height: "350px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Doughnut data={data} options={options} />
    </div>
  );
}

export default GanttFinanceiroProjeto;
